// @flow

import 'isomorphic-fetch'
import { getApiBaseUrlWithOrg, checkHttpStatus, getApiHeaders } from '../utils'
import { basicGet } from '../utils/api'
import { getErrorAction } from '../utils/actions'
import type { Action } from '../types/actions/topicclouds'
import type { APIError } from '../types'

export const FETCH_TOPIC_CLOUDS_REQUEST = 'FETCH_TOPIC_CLOUDS_REQUEST'
export const FETCH_TOPIC_CLOUDS_SUCCESS = 'FETCH_TOPIC_CLOUDS_SUCCESS'
export const FETCH_TOPIC_CLOUDS_FAILURE = 'FETCH_TOPIC_CLOUDS_FAILURE'
export const FETCH_TOPIC_CLOUD_REQUEST = 'FETCH_TOPIC_CLOUD_REQUEST'
export const FETCH_TOPIC_CLOUD_SUCCESS = 'FETCH_TOPIC_CLOUD_SUCCESS'
export const FETCH_TOPIC_CLOUD_FAILURE = 'FETCH_TOPIC_CLOUD_FAILURE'
export const FETCH_TOPIC_REQUEST = 'FETCH_TOPIC_REQUEST'
export const FETCH_TOPIC_SUCCESS = 'FETCH_TOPIC_SUCCESS'
export const FETCH_TOPIC_FAILURE = 'FETCH_TOPIC_FAILURE'
export const CLEAR_CURRENT_TOPIC_CLOUD = 'CLEAR_CURRENT_TOPIC_CLOUD'

export function fetchTopicCloudsRequest(): Action {
  return {
    type: FETCH_TOPIC_CLOUDS_REQUEST
  }
}

export function fetchTopicCloudsSuccess(response: {
  topic_clouds: Array<Object>
}): Action {
  return {
    type: FETCH_TOPIC_CLOUDS_SUCCESS,
    topicclouds: response.topic_clouds
  }
}

export function fetchTopicCloudsFailure(error: APIError): Action {
  return getErrorAction(FETCH_TOPIC_CLOUDS_FAILURE, error)
}

export function fetchTopicCloudRequest(): Action {
  return {
    type: FETCH_TOPIC_CLOUD_REQUEST
  }
}

export function fetchTopicCloudSuccess(response: {
  topic_cloud: Object
}): Action {
  return {
    type: FETCH_TOPIC_CLOUD_SUCCESS,
    topiccloud: response.topic_cloud
  }
}

export function fetchTopicCloudFailure(error: APIError): Action {
  return getErrorAction(FETCH_TOPIC_CLOUD_FAILURE, error)
}

export function fetchTopicRequest(): Action {
  return {
    type: FETCH_TOPIC_REQUEST
  }
}

export function fetchTopicSuccess(response: { topic: Object }): Action {
  return {
    type: FETCH_TOPIC_SUCCESS,
    topic: response.topic
  }
}

export function fetchTopicFailure(error: APIError): Action {
  return getErrorAction(FETCH_TOPIC_FAILURE, error)
}

export function clearCurrentTopicCloud(): Action {
  return {
    type: CLEAR_CURRENT_TOPIC_CLOUD
  }
}

export function fetchTopicClouds(): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(fetchTopicCloudsRequest())
    try {
      const response = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(state.organization.orgId)}/topic_clouds`,
          {
            method: 'GET',
            headers: getApiHeaders(state)
          }
        )
      )
      const json = await response.json()
      dispatch(fetchTopicCloudsSuccess(json))
      // on load of the Topic Clouds route, we need to auto fetch the first topic cloud
      dispatch(fetchTopicCloud(json.topic_clouds[0].id))
    } catch (error) {
      dispatch(fetchTopicCloudsFailure(error))
    }
  }
}

export function fetchTopicCloud(topicCloudId: number): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/topic_clouds/${topicCloudId}`

    dispatch(fetchTopicCloudRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )

      const json = await response.json()
      dispatch(fetchTopicCloudSuccess(json))
      // we need to auto fetch the first topic if there isn't one in state
      if (json.topic_cloud.topics.length > 0) {
        dispatch(fetchTopic(json.topic_cloud.topics[0].id))
      }
    } catch (error) {
      dispatch(fetchTopicCloudFailure(error))
    }
  }
}

export function fetchTopic(topicId: number): Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/topic_clouds/${state.topicclouds.currentTopicCloud.id}/topics/${topicId}`
    return basicGet(
      state,
      dispatch,
      url,
      fetchTopicRequest,
      fetchTopicSuccess,
      fetchTopicFailure
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/topicclouds.js